export interface QuoteInput {
    quoteInfo: QuoteInfo;
    customerInfo: CustomerInfo;
    productItems: ProductInfo[];
}

interface QuoteInfo {
    quoteNo: string;
    date: string;
    validUntil: string;
    shippingCarrier: string;
    shippingCost: number | null;
    shippingTerms: string;
    remark: string;
    discount: number | null;
    totalProductPrice: number | null;
    netPrice: number | null;
    isVat: boolean;
    // true → the entered prices already carry VAT (backed out, net = sum);
    // false → VAT is added on top, a quotation's normal stance.
    priceIncludesVat: boolean;
    vatAmount: number | null;
    hidePaymentMethod: boolean;
    hideSignatureFields: boolean;
    isSigned: boolean;
    customTitle: string;
    billingNote: boolean;
}

interface CustomerInfo {
    name: string;
    taxId: string;
    branch: string;
    postCode: string;
    province: string;
    district: string;
    subDistrict: string;
    address1: string;
    fullAddress: string;
    useCustomAddress: boolean;
    customAddress: string;
}

export interface ProductInfo {
    itemNo: number;
    description: string;
    unitPrice: number;
    quantity: number;
    amount: number;
}

const inputMomentFormat = 'YYYY-MM-DD';

const initialQuoteInput: QuoteInput = {
    quoteInfo: {
        quoteNo: '',
        date: '',
        validUntil: '',
        shippingCarrier: '',
        shippingCost: null,
        shippingTerms: '',
        remark: '',
        discount: null,
        totalProductPrice: null,
        netPrice: null,
        // On by default (user decision 2026-08-28): quotes are normally the
        // VAT-registered company quoting; switch off for the rare shop-brand
        // quote instead of on for the common case.
        isVat: true,
        priceIncludesVat: false,
        vatAmount: null,
        hidePaymentMethod: false,
        hideSignatureFields: false,
        isSigned: false,
        customTitle: '',
        billingNote: false,
    },
    customerInfo: {
        name: '',
        taxId: '',
        branch: '',
        postCode: '',
        province: '',
        district: '',
        subDistrict: '',
        address1: '',
        fullAddress: '',
        useCustomAddress: false,
        customAddress: '',
    },
    productItems: [],
};
import { cloneDeep } from 'lodash';
const getInitialQuoteInput = (): QuoteInput => {
    return cloneDeep(initialQuoteInput);
};
export { inputMomentFormat, getInitialQuoteInput };
